

import React, { useState } from 'react';
function IOT() {
  const [activeAccordion, setActiveAccordion] = useState('collapseOne');

  const toggleAccordion = (id) => {
    setActiveAccordion(activeAccordion === id ? '' : id);
  };

  return (
    <>
      {/* Hero Area */}
      <div 
        className="inner-page-hero-area" 
        style={{
          backgroundImage: 'url(assets/img/all-images/bg/hero-bg1.png)',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover'
        }}
      >
        <img src="assets/img/elements/elements5.png" alt="" className="elements5" />
        <img src="assets/img/elements/elements4.png" alt="" className="elements4" />
        <img src="assets/img/elements/elements1.png" alt="" className="elements1 keyframe5" />
        <img src="assets/img/elements/elements16.png" alt="" className="elements16" />

        <div className="container">
          <div className="row">
            <div className="col-lg-6 m-auto">
              <div className="inner-header text-center heading1">
                <h1>Internet Of Things - IOT</h1>
                <div className="space28"></div>
                <a href="/">
                  Home <i className="fa-solid fa-angle-right"></i> 
                  <span>Internet Of Things - IOT</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Service Sidebar Area */}
      <div className="service-sidebar-area sp1">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 m-auto">
              <div className="service2-widget-sidebar" style={{padding: '0 !important'}}>
                <div className="img1 reveal image-anime">
                  <img src="assets/img/all-images/service/service-img17.png" alt="" />
                </div>
                <div className="space32"></div>
                <h3>Internet Of Things - IOT</h3>
                <div className="space20"></div>
                <p>
                  The Internet of Things is a rapidly growing field that involves connecting physical objects – from cars to appliances – to the internet. This allows those objects to be remotely monitored and controlled, making them easier to use and more efficient.
                </p>
                <div className="space14"></div>
                
                <div className="row">
                  <div className="col-lg-6 col-md-6">
                    <ul className="list">
                      <li>
                        <img src="assets/img/icons/check1.svg" alt="" />
                        <b>Secure & Scalable Architecture</b>
                      </li>
                      <li>
                        <img src="assets/img/icons/check1.svg" alt="" />
                        <b>E-commerce & CMS Solutions</b>
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <ul className="list">
                      <li>
                        <img src="assets/img/icons/check1.svg" alt="" />
                        <b>Custom Web Application Development</b>
                      </li>
                      <li>
                        <img src="assets/img/icons/check1.svg" alt="" />
                        <b>Responsive & Mobile-Friendly Design</b>
                      </li>
                    </ul>
                  </div>
                </div>
                
                <div className="space32"></div>
                <div className="pera-box">
                  {/* <h4>Safeguard Your Business With Advanced Cybersecurity</h4> */}
                  <div className="space12"></div>
                  <p>
                  One of the key benefits of the Internet of Things is edge computing. Edge computing involves processing tasks on the edge of the network, near the devices themselves. This allows devices to access data more quickly and easily, eliminating the need for data to travel back to central servers. The Internet of Things (IoT) is a growing trend that refers to the interconnectedness of physical devices with the internet. This interconnectedness allows devices to communicate with each other and with servers, and it enables users to access data from these devices. The IoT has many potential benefits, including increased efficiency and automation, better customer service, and increased safety. BLE (Bluetooth Low Energy) is another important technology in the IoT. BLE is a short-range wireless technology that is used to connect devices that are close to each other. It’s especially useful in applications like smart homes and retail stores, where you want to connect devices like security cameras and sensors to smart devices in your home or store.
                  </p>
                </div>
                
                <div className="space18"></div>
                <div className="row">
                  <div className="col-lg-6 col-md-6">
                    <div className="space30"></div>
                    <div className="img1 reveal image-anime">
                      <img src="assets/img/all-images/service/service-img15.png" alt="" />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <div className="space30"></div>
                    <div className="img1 reveal image-anime">
                      <img src="assets/img/all-images/service/service-img16.png" alt="" />
                    </div>
                  </div>
                </div>
                
                <div className="space32"></div>
                <h3>What We Provide</h3>
<div class="space20"></div>
<ul className="check-list">
  <li>
  <b>Narrowband IoT (NB-IoT)</b> – Uses wireless networks with limited range (around 10 meters).
  </li>
  <li>
    <b>Efficient Data Transfer</b> – Reduces data transmission, leading to faster and more efficient IoT implementations.
  </li>
  <li>
    <b>NFC (Near-Field Communication)</b> – Enables short-range data exchange by simply touching devices together.
  </li>
  <li>
<b>IoT Advantages</b> – Both NB-IoT and NFC improve connectivity, speed, and efficiency in IoT systems.
  </li>
  <li>
    <b>Right Platform Guidance</b> – Expert support in selecting the best platform for your needs.
  </li>
  <li>
    <b>Custom App Development</b> – Build tailored solutions to meet specific business requirements.
  </li>
  <li>
    <b>Success-Oriented Approach</b> – Following best practices ensures long-term business success.
  </li>
</ul>


                
                <div className="space48"></div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default IOT
